export const getIssueUserResolvableColor = (userResolvable?: boolean) => userResolvable ? 'green' : 'red';

export const getIssueUserResolvableText = (userResolvable?: boolean) => userResolvable ? 'Yes' : 'No';
